import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const LIBRARIES = gql`
  query Libraries($filter: LibraryFilter, $sort: LibrarySort) {
    libraries(filter: $filter, sort: $sort) {
      count
      data {
        id
        name
      }
    }
  }
`;

export const NEW_ORDERS_ADMIN = gql`
  query NewOrdersAdmin($filter: OrdersAdminFilter, $sort: AdminOrderSort) {
    newOrdersAdmin(filter: $filter, sort: $sort) {
      count
      data {
        libraryId
        name
        libraryNumber
        orderCount
      }
    }
  }
`;

export const PINCODE_WISE_NEW_ORDER_COUNT = gql`
  query PincodeWiseNewOrdersCount($where: LibraryUniqueInput) {
    pincodeWiseNewOrdersCount(where: $where) {
      data {
        userNumber
        orderCount
        pincode
        pincodeId
        firstName
        lastName
        userId
      }
    }
  }
`;

export const NEW_RETURN_ORDER_ADMIN = gql`
  query NewReturnOrderAdmin(
    $filter: OrdersAdminFilter
    $sort: ReturnAdminOrderSort
  ) {
    newReturnOrderAdmin(filter: $filter, sort: $sort) {
      count
      data {
        pincodeId
        pincode
        returnOrderCount
        firstName
        lastName
        userId
        userNumber
      }
    }
  }
`;

export const NEW_RETURN_ORDER_DETAILS_ADMIN = gql`
  query NewReturnOrderDetailsAdmin(
    $where: PincodeUniqueInput!
    $filter: OrdersAdminFilter
    $sort: ReturnAdminOrderSort
  ) {
    newReturnOrderDetailsAdmin(where: $where, filter: $filter, sort: $sort) {
      count
      data {
        firstName
        lastName
        name
        libraryNumber
        returnOrderCount
        userNumber
        userId
      }
    }
  }
`;

export const NEW_ORDERS_ADMIN_V2 = gql`
  query NewOrdersAdminV2($filter: OrderFilter, $sort: OrderSort) {
    newOrdersAdminV2(filter: $filter, sort: $sort) {
      count
      placedOrderCount
      confirmedOrderCount
      data {
        isPreOrder
        isDelayed
        isExpressDelivery
        isQuickDelivery
        totalOrdersCount
        isFirstOrder
        delayedInConfirmed
        transferOrderItemCount
        orderNumber
        metadata
        deliveryService
        id
        expectedDeliveryDate
        deliveryType
        orderType
        orderItemCount
        deliveryAttachments {
          key
          url
          deliveryAttachmentsType
        }
        cancelledBy
        deliveredOn
        deliveryPartner {
          id
          userNumber
          firstName
          lastName
        }
        pincode {
          pincode
        }
        library {
          city
          name
          id
          libraryNumber
        }
        user {
          id
          userNumber
          firstName
          lastName
          pincode {
            pincode
          }
        }
        createdAt
        status
        statusHistory {
          newStatus
          oldStatus
          createdAt
        }
        cancellationData {
          date
          additionalComment
          reason
          type
        }
        comment {
          isResolved
          comment
        }
        orderTags
        currentStatusTime
        nextStatusTime
      }
      configs {
        id
        key
        type
        value
      }
    }
  }
`;

export const FULFILMENT_POSSIBILITY_ORDERS_ADMIN = gql`
  query FulfilmentPossibilityOrdersAdmin($filter: OrderFilter, $sort: OrderSort) {
    fulfilmentPossibilityOrdersAdmin(filter: $filter, sort: $sort) {
      count
      placedOrderCount
      confirmedOrderCount
      data {
        picker {
          id
          firstName
          lastName
          userNumber
        }
        packer {
          id
          firstName
          lastName
          userNumber
        }
        inventoryUnits {
          id
          qrCode
          unitCode
          status
          shelfLocation
          rack {
            id
            name
          }
        }
        id
        status
        isPreOrder
        quantity
        toy {
          id
          toyNumber
          name
          brand {
            id
            name
          }
          bag {
            id
            name
            size
            image
          }
          images {
            key
            url
          }
        }
        stockAtBooking
        libraryInventory {
          id
          availableStock
          physicallyAvailableStock
          pendingDispatchCount
          rentedOut
          totalStock
        }
        transferOrders {
          id
          status
          transferOrderNumber
        }
        order {
          id
          orderNumber
          status
          isDelayed
          isExpressDelivery
          isQuickDelivery
          totalOrdersCount
          hasReservedItems
          isFirstOrder
          delayedInConfirmed
          transferOrderItemCount
          orderItemCount
          metadata
          deliveryService
          expectedDeliveryDate
          deliveryType
          orderType
          deliveryAttachments {
            key
            url
            deliveryAttachmentsType
          }
          cancelledBy
          deliveredOn
          createdAt
          currentStatusTime
          nextStatusTime
          deliveryPartner {
            id
            userNumber
            firstName
            lastName
          }
          pincode {
            pincode
          }
          library {
            city
            name
            id
            libraryNumber
          }
          user {
            id
            userNumber
            firstName
            lastName
            pincode {
              pincode
            }
          }
          cancellationData {
            date
            additionalComment
            reason
            type
          }
          comment {
            isResolved
            comment
          }
          orderTags
        }
      }
      configs {
        id
        key
        type
        value
      }
    }
  }
`;


export const NEW_ORDERS_COUNT_ADMIN_V2 = gql`
  query NewOrdersAdminV2($filter: OrderFilter, $sort: OrderSort) {
    newOrdersAdminV2(filter: $filter, sort: $sort) {
      count
      placedOrderCount
      confirmedOrderCount
    }
  }
`;

// Count-only variant for the Fulfilment Possibility tab badge.
export const FULFILMENT_POSSIBILITY_ORDERS_COUNT_ADMIN = gql`
  query FulfilmentPossibilityOrdersAdmin($filter: OrderFilter, $sort: OrderSort) {
    fulfilmentPossibilityOrdersAdmin(filter: $filter, sort: $sort) {
      count
    }
  }
`;

export const NEW_RETURN_ORDER_COUNT_ADMIN = gql`
  query returnOrdersAdmin(
    $filter: ReturnOrderItemFilter
    $sort: ReturnOrderSort
  ) {
    returnOrdersAdmin(filter: $filter, sort: $sort) {
      count
      returnRequestedOrderCount
    }
  }
`;

export const USER_ORDERS_ADMIN = gql`
  query userOrdersWithItems(
    $filter: UserOrdersWithItemsFilter
    $sort: OrderSort
    $where: UserUniqueInput!
  ) {
    userOrdersWithItems(filter: $filter, sort: $sort, where: $where) {
      count
      data {
        isPreOrder
        totalOrdersCount
        isFirstOrder
        delayedInConfirmed
        expectedDeliveryDate
        transferOrderItemCount
        orderNumber
        metadata
        id
        deliveryType
        orderType
        orderItemCount
        deliveryAttachments {
          key
          url
          deliveryAttachmentsType
        }
        cancelledBy
        deliveredOn
        deliveryPartner {
          id
          userNumber
          firstName
          lastName
        }
        pincode {
          pincode
        }
        library {
          name
          id
          libraryNumber
        }
        user {
          id
          userNumber
          firstName
          lastName
          pincode {
            pincode
          }
        }
        createdAt
        status
        cancellationData {
          date
          additionalComment
          reason
          type
        }
        comment {
          isResolved
          comment
        }

        statusHistory {
          newStatus
          oldStatus
          createdAt
        }
        orderTags
        scheduledOrders {
          id
          orderNumber
        }
      }
    }
  }
`;
